import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export const Truck = /*#__PURE__*/React.forwardRef((props, ref) => {
  const attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, Object.assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.434 9H15v3h4.233z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 17.5,
    r: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.148 7.971A2.008 2.008 0 0017.434 7H15V5a1 1 0 00-1-1H4c-1.103 0-2 .897-2 2v10c0 .746.416 1.391 1.023 1.734C3.146 19.553 4.65 21 6.5 21c1.759 0 3.204-1.309 3.449-3h3.102c.245 1.691 1.69 3 3.449 3s3.204-1.309 3.449-3H20c1.103 0 2-.897 2-2v-3a.995.995 0 00-.143-.515l-2.709-4.514zM15 9h2.434l1.8 3H15V9zM6.5 19c-.827 0-1.5-.673-1.5-1.5S5.673 16 6.5 16s1.5.673 1.5 1.5S7.327 19 6.5 19zm10 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
  }));
});
Truck.displayName = 'Truck';
export const TruckDimensions = {
  height: 24,
  width: 24
};